import { Entity } from '@core/entities/entity'
import { plainToInstance } from 'class-transformer'
import { IOrganisationAuthenticationConfig } from '@core/entities/organisation/IOrganisationAuthenticationConfig'

export class OrganisationAuthenticationConfig extends Entity<IOrganisationAuthenticationConfig> {
  id?: number
  organisationId: number
  enabled: boolean
  skipSsoUsers: boolean
  tokenValidityInSeconds: number
  enforceOn: string
  skipDurationInSeconds: number

  public static new(payload: unknown): OrganisationAuthenticationConfig {
    return plainToInstance(OrganisationAuthenticationConfig, payload)
  }
}
